import axios from "axios";

export function shopEdit(businessData) {
  let id = businessData.businessId;
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/eaa/shops/${id}`,
    data: {
        businessData
    }
  };
  return axios(config);
}

export function shopStatus(businessData) {
  let accountId = businessData.accountId;
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/eaa/eaa-shops/${accountId}/status`,
    data: {
        isEnabled: businessData.isEnabled
    }
  };
  return axios(config);
}